module.exports = __webpack_public_path__ + "static/media/head.ca294d68.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/head.png
// module id = 132
// module chunks = 10